import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "14",
  fill: "none",
  viewBox: "0 0 12 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.758 13.945c-1.313 0-1.961-.656-1.961-1.992V2.766c0-1.328.648-1.993 1.96-1.993h2.759v4.54c0 .828.39 1.218 1.218 1.218h4.47v5.422q0 1.992-1.97 1.992zm3.976-8.328c-.195 0-.304-.101-.304-.304V.827c.289.047.578.25.898.578L10.57 4.72c.328.336.524.61.563.898z"
    }, null, -1)
  ])))
}
export default { render: render }